<ion-header no-border>
  <app-close-button [isModal]="true"></app-close-button>
</ion-header>

<ion-content class="custom-inputs">
  <div class="medium">
    <div class="page-title">{{title}}</div>
    <form [id]="formId"></form>
  </div>
</ion-content>
